import styled, { css } from "styled-components";
import { styleTransformHelper as t } from "helpers";

export default styled.div(
  ({
    theme: {
      isMobile,
      color: {
        light0,
        light5,
        lightGreen,
        lightRed,
        dark3,
        dark4,
        primary1,
        green,
        red,
      },
      utils: { flex },
    },
  }) =>
    t(css`
      margin: 24px;
      .dashboard {
        &__meet {
          ${flex("center", "center", "column")};
          background-color: ${isMobile ? "transparent" : light0};
          padding: 48px;
          &--title {
            font-style: normal;
            font-weight: 600;
            font-size: 24px;
            color: ${dark3};
            margin: 0;
          }
          &--dec {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: ${dark3};
            margin: 24px;
          }
          &--action {
            ${flex()};
            column-gap: 30px;
            width: 100%;
            text-align: center;
            button {
              min-width: 300px;
            }
            .create {
              background-color: transparent !important;
              color: ${primary1};
            }
          }
        }
        &__meetHistory {
          padding: 16px;
          background-color: ${light0};
          .ant-table table {
            table-layout: auto;
            border: 1px solid ${dark4};
            border-radius: 8px;
            overflow: hidden;
            .ant-table-thead > tr > th {
              background: transparent;
            }
            thead th {
              color: ${light5} !important;
            }
            .link {
              ${flex("flex-start")};
              &__text {
                color: ${primary1};
                margin-left: 8px;
              }
              &__btn {
                background-color: transparent;
                border: none;
                cursor: pointer;

                .icon {
                  display: flex;
                  column-gap: 30px;
                  width: 16px;
                }
              }
            }
            .status {
              width: 68px;
              height: 24px;
              border-radius: 4px;
              cursor: pointer;
              border: none;
              font-style: normal;
              font-weight: 600;
              font-size: 12px;
              line-height: 16px;
              text-transform: capitalize;
              &.active {
                background-color: ${lightGreen};
                color: ${green};
              }
              &.expired {
                background-color: ${lightRed};
                color: ${red};
              }
            }
            .action {
              ${flex("flex-end")}
              .icon {
                width: 24px;
              }
              .icon-settingIcon {
                path {
                  stroke: ${primary1};
                }
              }
              a {
                height: 40px;
                padding: 8px 12px !important;
              }
            }
          }

          .ant-table-container table > thead > tr:first-child th:last-child {
            border-top-right-radius: 8px;
          }
          .ant-table-container table > thead > tr:first-child th:first-child {
            border-top-left-radius: 8px;
          }
        }
      }
    `)
);
